import * as yup from "yup";

// Same rules as the API's ContactDataRules. Empty is allowed; on edit, a value saved before the rules existed passes
// as long as it is unchanged (form context `saved`, keyed by field name).
type Ctx = { options: { context?: { saved?: Record<string, unknown> } }; path: string };
const unchanged = (value: string | null | undefined, ctx: Ctx) => {
  const saved = ctx.options.context?.saved?.[ctx.path];
  return saved != null && saved !== "" && value === saved;
};
const optional = (test: (v: string) => boolean) => (value: string | null | undefined, ctx: Ctx) =>
  !value || !value.trim() || unchanged(value, ctx) || test(value.trim());

export const optionalEmail = () =>
  yup
    .string()
    .nullable()
    .test(
      "email",
      "Niepoprawny adres email",
      optional((v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)),
    );

export const optionalPhone = () =>
  yup
    .string()
    .nullable()
    .test(
      "phone",
      "Niepoprawny numer telefonu",
      optional((v) => /^\+?[0-9 ()-]{6,20}$/.test(v) && (v.match(/\d/g)?.length ?? 0) >= 6),
    );

export const optionalPostCode = () =>
  yup
    .string()
    .nullable()
    .test(
      "postCode",
      "Kod pocztowy w formacie 00-000",
      optional((v) => /^\d{2}-\d{3}$/.test(v)),
    );

export const optionalCoordinate = (min: number, max: number) =>
  yup
    .string()
    .nullable()
    .test(
      "coordinate",
      `Podaj liczbę od ${min} do ${max}`,
      optional((v) => {
        const n = Number(v.replace(",", "."));
        return v.replace(",", ".").match(/^-?\d+(\.\d+)?$/) !== null && n >= min && n <= max;
      }),
    );
